import { Component, HostBinding, Injector, OnInit, Input, ɵbypassSanitizationTrustStyle } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@shared/base/Base.Component';
import { LoginModel } from '@shared/models/restapi/Login.Model';
import { DataPollingService } from '@shared/service/datapolling/DataPolling.Service';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import {
    SafeCountCompatiblityCheckService,
} from '@shared/service/safecountcapabilitycheck/SafeCountCapabilityCheck.Service';
import { UserCurrentService } from '@shared/service/user/User.Current.Service';
import { BrowserUtility } from '@shared/utility/Browser.Utility';
import { map } from 'rxjs/operators';
import { isNullOrUndefined } from '@shared/utility/General.Utility';

@Component({
    selector: 'shr-login',
    templateUrl: './Login.Component.html',
    styleUrls: ['./Login.Component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {
    public static className: string = 'LoginComponent';

    @HostBinding()
    public id: string = 'shr-login';

    @Input()
    public backgroundColor: string = '#fdfdfd'

    @Input()
    public showBaseTitle: boolean = true;

    public loginProcess: ProcessMonitorServiceProcess;
    public safeCountCompatiblityProcess: ProcessMonitorServiceProcess;
    public error: string;
    public loginModel: LoginModel;
    public loadTestComplete: boolean;
    public safeCountCompatible: boolean = false;

    public constructor(
        private readonly _dataPollingService: DataPollingService,
        private readonly _matDialog: MatDialog,
        private readonly _currentUserService: UserCurrentService,
        private readonly _routerService: Router,
        private readonly _activatedRoute: ActivatedRoute,
        private readonly _safeCountCompatiblityCheck: SafeCountCompatiblityCheckService,
        private readonly _injector: Injector) {
        super(_injector);

        this._matDialog.closeAll();

        if (!BrowserUtility.isCompatible) {
            this._routerService.navigate(['/', 'browser-incompatible'], { queryParamsHandling: 'preserve' });
        }

        this._dataPollingService.stopAll();

        this._currentUserService.refresh();

        this.loginProcess = this.processMonitorService.getProcess(LoginComponent.className, 'Login user in');
        this.safeCountCompatiblityProcess = this.processMonitorService.getProcess(LoginComponent.className, 'Safe count compatibility');

        this._matDialog.closeAll();

        this.loginModel = new LoginModel();

        this.loadTestComplete = false;

        let safeCountCheckRequired: boolean = false;
        this._activatedRoute.data.pipe(map(d => d.safeCountCheckRequired)).subscribe(val => {
            if (this.isNullOrUndefined(val)) {
                safeCountCheckRequired = false;
            }
            else {
                safeCountCheckRequired = val;
            }
        });

        if (safeCountCheckRequired) {
            this.addSubscription(this.observableHandlerBase(this._safeCountCompatiblityCheck.checkSafeCountCompatible(this.safeCountCompatiblityProcess), this.safeCountCompatiblityProcess).subscribe(
                result => {
                    this.safeCountCompatible = result;
                }
            ), this.safeCountCompatiblityProcess);
        }
        else {
            this.safeCountCompatible = false;
        }

        this.onLoadLoginTest();
    }

    public login(): void {
        this.processMonitorService.started(this.loginProcess);

        this.addSubscription(this.observableHandlerBase(this._currentUserService.login(this.loginModel, this.loginProcess), this.loginProcess).subscribe(
            result => {
                if (result.success === true) {
                    this._routerService.navigate(['/'], { queryParamsHandling: 'preserve' });
                } else {
                    this.error = result.error;
                }
            }
        ), this.loginProcess);
    }

    public onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.login();
        }
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.addSubscription(this._activatedRoute.data.subscribe(data => {
            if (!isNullOrUndefined(data) && !isNullOrUndefined(data.backgroundColor)) {
                this.backgroundColor = data.backgroundColor;
            }
            if (!isNullOrUndefined(data) && !isNullOrUndefined(data.showBaseTitle)) {
                this.showBaseTitle = data.showBaseTitle;
            }
        }));
    }

    private onLoadLoginTest() {
        this.processMonitorService.started(this.loginProcess);

        this.addSubscription(this.observableHandlerBase(this._currentUserService.login(this.loginModel, this.loginProcess), this.loginProcess).subscribe(
            result => {
                this.loadTestComplete = true;

                if (result.success === true) {
                    this._routerService.navigate(['/'], { queryParamsHandling: 'preserve' });
                }
            }
        ), this.loginProcess);
    }
}
